<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on: onMenu, attrs }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: onTooltip }">
          <div>
            <v-icon
              class="icon"
              color="#39537a"
              v-bind="attrs"
              v-on="{ ...onMenu, ...onTooltip }"
              size="36px"
              @click="moreInfo"
              :disabled="signed || !can('accion:reglasregisinfo')"
              >mdi-information-outline</v-icon
            >
          </div>
        </template>
        <span>{{ $tc("editRegistrations.moreInfoRules") }} </span>
      </v-tooltip>
    </template>
    <v-list class="list__">
      <v-list-item-group color="primary">
        <v-list-item
          v-for="(action, index) in getInfoRules"
          :key="index"
          two-line
          class="list__item"
          color="primary"
        >
          <v-list-item-content class="list__content">
            <v-list-item-title>{{ action.rule }}</v-list-item-title>
            <p style="color: grey">{{ action.description }}</p>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import permissions from "../../../mixins/permissions";
import registrations from "@/store/gestionTiempos/registrations";
export default {
  mixins: [permissions],
  computed: {
    signed() {
      return this.$store.state.gestionTiempos.signed;
    },
    getInfoRules() {
      return registrations.state.rules;
    },
  },
  methods: {
    moreInfo() {
      registrations.dispatch("getInfoRules");
    },
  },
};
</script>

<style scoped>
.btn__info {
  background-color: #39537a !important;
  border-radius: 50px;
  min-width: 45px !important;
  padding: 0px !important;
  margin-left: 15px;
}

.btn__info:hover {
  background-color: #82a1d0 !important;
}

.list__item {
  width: 598px !important;
  cursor: unset;
}

.p__action {
  margin: 0px !important;
}

.list__item:hover {
  background-color: rgba(85, 149, 205, 0.097);
  color: #82a1d0 !important;
}

.list__ {
  max-height: 280px !important;
  overflow-y: scroll;
  scrollbar-width: unset;
}

@media (min-width: 300px) and (max-width: 500px) {
  .icon {
    margin-bottom: 6px;
    margin-left: 10px !important;
  }

  .list__content {
    max-width: 300px !important;
  }

  .list__item {
    max-width: 320px !important;
  }
}
</style>
